import React from "react";
import {getItemLabel, getItemMeta} from "./searchSelectorUtils";

function SearchSelectorPanelList({
    list,
    entity,
    data,
    multiSelect,
    checkedIds,
    onSelect,
    onMultiCheckChange,
    /** id가 없을 때 name/label로 active 매칭(엑셀 등 특수 케이스) */
    matchActiveByNameWhenIdMissing = false,
}) {
    if (!list?.length) return null;

    return (
        <ul className="search-selector-panel-list-inner">
            {list.map((item, index) => {
                const selectedById = String(data?.id) === String(item.id);
                const selectedByLabel =
                    matchActiveByNameWhenIdMissing
                    && (data?.id == null)
                    && !!data
                    && String(getItemLabel(data) ?? "").trim() !== ""
                    && String(getItemLabel(data) ?? "").trim()
                        === String(getItemLabel(item) ?? "").trim();
                const isSelected = selectedById || selectedByLabel;
                /** 단일 선택 모드에서는 checkedIds(다중선택 잔재)를 active로 반영하지 않음 */
                const isChecked = multiSelect && checkedIds?.includes(item.id);
                const label = getItemLabel(item);
                const meta = getItemMeta(item, entity);

                return (
                    <li key={item.id ?? index}>
                        <div
                            className={[
                                "search-selector-panel-row",
                                isSelected || isChecked ? "is-active" : "",
                            ].filter(Boolean).join(" ")}
                            onClick={() => {
                                if (multiSelect) {
                                    onMultiCheckChange?.(item, !isChecked);
                                } else {
                                    onSelect(item);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    if (multiSelect) {
                                        onMultiCheckChange?.(item, !isChecked);
                                    } else {
                                        onSelect(item);
                                    }
                                }
                            }}
                        >
                            {multiSelect && (
                                <input
                                    type="checkbox"
                                    className="search-selector-panel-checkbox"
                                    checked={!!isChecked}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        onMultiCheckChange?.(item, e.target.checked);
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            )}
                            <span className="search-selector-panel-row-name" title={label}>{label}</span>
                            {meta && (
                                <span className="search-selector-panel-row-meta" title={meta}>{meta}</span>
                            )}
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}

export default SearchSelectorPanelList;
